import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Star, CheckCircle2, ArrowRight } from 'lucide-react';
const CALENDLY_URL = 'https://calendly.com/vantixcredit/diagnostico-de-credito';
const contactInfo = [{
  icon: Phone,
  label: 'Llámanos o Escríbenos',
  value: '+1 (407) 367-8672'
}, {
  icon: Mail,
  label: 'Correo Oficial',
  value: 'eduardo@vantixcreditsolutions.com'
}, {
  icon: MapPin,
  label: 'Servicio',
  value: 'Completamente Hecho Para Ti'
}];
const consultaItems = ['Revisamos tu situación actual y qué metas tienes', 'Identificamos oportunidades de restauración y crecimiento', 'Te damos un plan detallado de lo que debes hacer', 'Creamos un presupuesto para ti'];
const sessionStats = [{
  value: '40 min'
}, {
  value: 'Gratis'
}];
export function Booking() {
  return <section id="agendar" className="bg-black py-20 md:py-24 px-4 sm:px-6 lg:px-8 border-t border-white/5 relative overflow-hidden" data-id="element-13" data-mp="1f9oacf9kxu0o">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-14" data-mp="1qvpdnavesfnj" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-15" data-mp="20vg6l84bmmli">
        {/* Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-14 md:mb-16" data-id="element-16" data-mp="20tdi4sith1iw">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-17" data-mp="1d5vlaikp3d92">
            Un Solo Paso
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-18" data-mp="khq2409ahwbc">
            Has Llegado Hasta Aquí.
            <br data-id="element-19" data-mp="2kiy1fkj4fed3" />
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-20" data-mp="2khd7nx4mrzga">
              Ahora Toma Acción.
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-21" data-mp="2ubdhuderruvv">
            Agenda tu diagnóstico gratuito de 40 minutos y sal de la llamada con
            un plan claro para tu crédito.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start" data-id="element-22" data-mp="26iwqtdd20skf">
          {/* Left: contact info + checklist */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="space-y-8 order-2 lg:order-1" data-id="element-23" data-mp="2ajqdk3erg1bq">
            {/* Contact rows */}
            <div className="space-y-5" data-id="element-24" data-mp="apib96n30n">
              {contactInfo.map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-25" data-mp="3rclu8xj5lw97" data-mpi={i}>
                  <div className="h-12 w-12 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center shrink-0" data-id="element-26" data-mp="3ncbjz8obwjoj">
                    <item.icon className="h-5 w-5 text-amber-400" strokeWidth={2} data-id="element-27" data-mp="3iamb9zokwi3m" />
                  </div>
                  <div data-id="element-28" data-mp="38fb1zwvxw339">
                    <div className="text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-1" data-id="element-29" data-mp="38gm6y014fgvy">
                      {item.label}
                    </div>
                    <div className="text-white font-semibold text-lg" data-id="element-30" data-mp="16mwe8h6ps4ex">
                      {item.value}
                    </div>
                  </div>
                </div>)}
            </div>

            {/* En tu consulta box */}
            <div className="rounded-3xl border border-white/[0.08] bg-gradient-to-b from-white/[0.04] to-white/[0.01] p-8" data-id="element-31" data-mp="1envoeec2v3gi">
              <div className="text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-6" data-id="element-32" data-mp="10p4fr7fzi9zr">
                En tu consulta:
              </div>
              <ul className="space-y-4" data-id="element-33" data-mp="14rsnfbsypav5">
                {consultaItems.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-34" data-mp="qwghs9d9pzzg" data-mpi={i}>
                    <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-35" data-mp="vq1hc5uif20r" />
                    <span className="text-white/70 font-light" data-id="element-36" data-mp="lz6t4vxpdsco">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Right: booking card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="rounded-3xl border border-amber-500/30 bg-gradient-to-b from-amber-500/[0.06] to-transparent shadow-2xl shadow-amber-500/5 p-8 md:p-12 text-center order-1 lg:order-2" data-id="element-37" data-mp="cza3os3hopgk">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-38" data-mp="7byflogx9axj">
              Agenda Tu Sesión
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-10 max-w-md mx-auto" data-id="element-39" data-mp="m3qi2zvmauhu">
              Selecciona el día y la hora que mejor te convengan. En 40 minutos
              tendrás claridad total sobre tu camino a un mejor crédito y
              financiamiento.
            </p>

            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-8 py-4 rounded-full transition-all text-lg shadow-2xl shadow-amber-500/30 w-full" data-id="element-40" data-mp="q529nay1xpso">
              Reservar mi consulta gratis
              <ArrowRight className="h-5 w-5" data-id="element-41" data-mp="6gb1p54d86ta" />
            </a>

            {/* Divider */}
            <div className="h-px w-full bg-white/[0.08] my-10" data-id="element-42" data-mp="6ioybiep1r2y" />

            {/* Session stats */}
            <div className="flex items-center justify-center gap-12" data-id="element-43" data-mp="geih3jj0agt6">
              {sessionStats.map((stat, i) => <div key={i} className="text-xl md:text-2xl font-bold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-44" data-mp="kglu4clbptgk" data-mpi={i}>
                  {stat.value}
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}